/**
 * @namespace Stores
 * @category Stores
 * @module alert-store
 * */

import { generateShortId } from '@/utils/crypto.js'

export default {
  namespaced: true,
  state: {
    alerts: [],
  },
  getters: {
    alerts(state) {
      return state.alerts
    },
  },
  mutations: {
    addAlert(state, alert) {
      if (state.alerts.length === 0) {
        state.alerts.push(alert)
      }
    },
    removeAlert(state, id) {
      if (state.alerts.length === 0) {
        return
      }
      if (!id && state.alerts.length > 0) {
        id = state.alerts[state.alerts.length - 1].id //Grab last
      }
      const index = state.alerts.findIndex((value) => value.id == id)
      if (index !== -1) {
        state.alerts.splice(index, 1)
      }
    },
  },
  actions: {
    clearLastMessage({ state, dispatch }) {
      if (state.alerts.length > 0) {
        dispatch('removeAlert', state.alerts[state.alerts.length - 1].id)
      }
    },
    removeAlert({ commit }, id) {
      commit('removeAlert', id)
    },
    /**
     * @todo Do not dispatch this action directly, use toast.ts:showToast instead!
     * @param {*} param0
     * @param {*} alert
     */
    addAlert({ commit }, alert) {
      const id = generateShortId()
      commit('addAlert', {
        ...alert,
        id,
      })
      if (alert.timeout) {
        setTimeout(() => {
          commit('removeAlert', id)
        }, alert.timeout)
      }
    },
  },
}
